import * as React from 'react'
import * as Redux from 'react-redux'
import styled from 'styled-components'

import * as model from '@owl-nest/models'
import { t, tc } from '@owl-nest/localize'
import { UseAuth } from '@owl-nest/redux-wrapper/src/user/identity/useAuth'

import * as plume from '@ulule/owl-kit-components/next'

import { RootState } from '../../../../reducers'
import * as projectModel from '../../../models/project'
import { useSharing } from '@owl-nest/sharing'

type SuccessMessageProps = {
  auth: UseAuth
}

export function SuccessMessage({ auth }: SuccessMessageProps): React.ReactElement<SuccessMessageProps> {
  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)
  const user = auth.type === 'loggedin' ? auth.user : undefined

  const { shareTo } = useSharing<projectModel.ExtraFields>('coming-soon', project, user)

  return (
    <Wrapper>
      <plume.illustrations.twoToned.EnvelopeWithHeart size={99} />

      <Texts>
        <plume.styles.heading.L>{t('Thank you!')}</plume.styles.heading.L>
        <plume.styles.copy.S.regular>
          {t(
            'Your registration has been taken into account. You will be notified of the launch and then of the project posts by email.',
          )}
        </plume.styles.copy.S.regular>
      </Texts>

      <Share>
        <ShareText>{t('Share the project:')}</ShareText>
        <SocialButtonList>
          <plume.SocialButton platform="facebook" onClick={() => shareTo('facebook')} />
          <plume.SocialButton platform="twitter" onClick={() => shareTo('twitter')} />
          <plume.SocialButton platform="messenger" onClick={() => shareTo('messenger')} />
        </SocialButtonList>
      </Share>
    </Wrapper>
  )
}

const SocialButtonList = styled.div`
  margin: 15px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;

  ${plume.SocialButton} {
    margin-right: 8px;
    width: 50px;
    height: 50px;
    padding: 15px;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    justify-content: flex-start;
  }
`

const Wrapper = styled.div`
  align-items: flex-start;
  display: flex;
  padding: 42px 35px;
  flex-direction: column;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }
`

const ShareText = styled(plume.styles.copy.S.regular)`
  margin-bottom: 11px;
`

const Texts = styled.div`
  border-bottom: 1px solid ${plume.COLORS.GREY_SHADE_5};
  padding-bottom: 11px;
  margin-top: 10px;

  ${plume.styles.heading.L} {
    margin-bottom: 16px;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    border-bottom: 0px solid;
    border-right: 1px solid ${plume.COLORS.GREY_SHADE_5};
    margin-left: 45px;
    margin-top: 0px;
    padding-bottom: 0px;
    padding-right: 18px;
    width: 460px;

    ${plume.styles.heading.L} {
      margin-bottom: 22px;
    }
  }
`

const Share = styled.div`
  margin-top: 14px;
  text-align: center;
  width: 100%;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    margin-left: 37px;
    margin-top: 0px;
    text-align: left;
    width: 166px;
  }
`
